<template>
  <message-dialog
    :open="visible"
    closable
    :persistent="false"
    actions-in-row
    data-testid="IndividualSubShutdownDialog"
    @update:open="visible = $event"
    @close="closeTransient"
  >
    <template #text>
      Sākot ar <strong>2026. gada 1. augustu</strong>, platformā Soma būs pieejami tikai izglītības iestāžu abonementi. Jūsu individuālais abonements tiks atcelts automātiski, un to varēs izmantot līdz pašreizējā abonementa beigām attiecīgajā mēnesī. Aicinām izmantot kolektīvos abonementus ar skolvadības pasēm. Ja jums šādas iespējas nav, lūdzu, sazinieties, rakstot uz <a href="mailto:soma@lielvards.lv">soma@lielvards.lv</a>.
    </template>

    <template #actions>
      <v-btn variant="outlined" rounded="pill" data-testid="DismissPermanently" @click="dismissPermanently">
        Iepazinos, vairāk nerādīt
      </v-btn>
      <v-btn
        variant="text"
        rounded="pill"
        href="https://atbalsts.soma.lv/article/271-individualo-abonementu-izmainas"
        target="_blank"
        rel="noopener"
        data-testid="ReadMore"
      >
        Vairāk
      </v-btn>
      <v-btn variant="text" rounded="pill" data-testid="GoToSubscriptions" @click="goToSubscriptions">
        Abonementi
      </v-btn>
    </template>
  </message-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue"

import { useNoticesStore } from "~/stores/noticesStore"

export const INDIVIDUAL_SUB_NOTICE_ID = "individualSubShutdown"

export default defineComponent({
  setup() {
    const noticesStore = useNoticesStore()
    return { noticesStore }
  },

  data() {
    return {
      visible: true,
    }
  },

  methods: {
    closeTransient() {
      this.noticesStore.skipForSession(INDIVIDUAL_SUB_NOTICE_ID)
      this.visible = false
    },

    dismissPermanently() {
      this.noticesStore.dismissPermanently(INDIVIDUAL_SUB_NOTICE_ID)
      this.visible = false
    },

    goToSubscriptions() {
      this.noticesStore.skipForSession(INDIVIDUAL_SUB_NOTICE_ID)
      this.visible = false
      navigateTo("/profile/abonements")
    },
  },
})
</script>
